import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const MobileContainer = styled.div`
  display: flex;
  row-gap: 32px;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const TabletContainer = styled.div`
  display: none;

  ${theme.breakpoints.up("tablet")} {
    display: flex;
    row-gap: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    display: none;
  }
`;

export const DesktopContainer = styled.div`
  display: none;

  ${theme.breakpoints.up("desktop")} {
    display: flex;
    row-gap: 48px;
  }
`;
